export enum Insurer {
  Unknown,
  Arch,
  Allianz,
}

export interface InsurerMeta {
  id: Insurer;
  name: string;
  description: string;
  website: string;
  policyWording: string;
  excessBasis: string;
  limitOfIndemnityBasis: string;
  excess: string;
  territorialLimits?: string;
  legalExpenses?: InsurerMetaLegalExpenses;
}

interface InsurerMetaLegalExpenses {
  limitOfIndemnity: string;
  limitOfIndemnityBasis: string;
  excess: string;
  insurer: string;
}

export interface InsurerSummary {
  id: number;
  insurerId: number;
  quoteId: number;
  type: Insurer;
  name: string;
}

export type InsurerMetaDef = Record<
  number,
  Record<number | 'DEFAULT', Record<number, Partial<InsurerMeta>>>
>;
